import React from "react";
import AtocSeatReservations from "./AtocSeatReservations";
import * as s from "./SeatReservations.module.css";
const groupByOriginStation = (seats) => {
  const grouped = {};
  seats.forEach((seat) => {
    if (!seat.originStation)
      return;
    const origin = seat.originStation;
    if (!grouped[origin]) {
      grouped[origin] = [];
    }
    grouped[origin].push(seat);
  });
  return Object.keys(grouped).map((origin) => ({
    originStation: origin,
    seats: grouped[origin]
  }));
};
const SplitSaveReservations = ({ seatReservations }) => {
  const groupedSeatReservations = groupByOriginStation(seatReservations);
  return /* @__PURE__ */ React.createElement("div", {
    className: s.splitSaveContainer
  }, groupedSeatReservations.map(({ originStation, seats }) => /* @__PURE__ */ React.createElement(AtocSeatReservations, {
    key: originStation,
    seatReservations: seats
  })));
};
var SplitSaveReservations_default = SplitSaveReservations;
export {
  SplitSaveReservations_default as default
};
